import React, { useEffect, useState } from 'react';
import { Button, Typography, Box } from '@mui/material';
import InsuranceCard from './InsuranceCard';

type Props = {
  cardList: any;
  onInitiateNewCard: any;
  onEditCard: (id: string) => void;
  onDeleteCard: (index: any) => void;
  onUpload: () => void;
  onSetManual: () => void;
  openSMS?: boolean;
  cardCheck: boolean;
};

const CardList = ({
  cardList,
  onEditCard,
  onDeleteCard,
  onSetManual,
  openSMS,
  cardCheck,
}: Props) => {
  const [animateCards, setAnimateCards] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setAnimateCards(true), 10);
    return () => clearTimeout(timeout);
  }, [cardList]);

  return (
    <>
      {cardList.length > 0 && (
        <div className="card-list">
          {cardList.map((card: any, index: number) => {
            const {
              _id,
              insuredID = '',
              insuranceCarrier = '',
              frontPhoto,
              backPhoto,
            } = card;

            const cardStyle: React.CSSProperties = {
              opacity: animateCards ? 1 : 0,
              transform: animateCards ? 'translateY(0)' : 'translateY(-20px)',
              transition: 'opacity 0.4s ease, transform 0.4s ease',
              transitionDelay: `${index * 200}ms`,
            };

            return (
              <div key={_id} style={cardStyle}>
                <InsuranceCard
                  _id={_id}
                  insuredID={insuredID}
                  insuranceCarrier={
                    insuranceCarrier.length > 24
                      ? insuranceCarrier.substring(0, 24).trim() + '...'
                      : insuranceCarrier
                  }
                  frontPhoto={frontPhoto}
                  backPhoto={backPhoto}
                  index={index}
                  onEditCard={onEditCard}
                  onDeleteCard={onDeleteCard}
                />
              </div>
            );
          })}
        </div>
      )}

      {!openSMS && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, my: 1 }}>
          <Button variant="contained" onClick={onSetManual} sx={{ color: '#fff', gap: '6px' }}>
            Add Insurance Card
          </Button>
        </Box>
      )}
    </>
  );
};

export default CardList;